/**
 * 
 * @version 12.4.0 #756 MLIBJS-121 Export directives, filters, helpers and services as a node module.
 *
 * @author Erik Orozco <eorozco@intersog.com>
 * 
 * @copyright (c) 2020 Build Centrix
 *
 */

var directives = require('./lib/angularjs/directives');
var filters = require('./lib/angularjs/filters');
var helpers = require('./lib/angularjs/helpers');
var services = require('./lib/angularjs/services');
module.exports = { directives, filters, helpers, services }

// EOF